<template>
  <div class="option-date">
    <van-nav-bar title="重复" :fixed="true" style="margin-bottom:15px;" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <div class="more-box">
      <div class="more-flex" v-for="(item,index) in dateList" :key="index" @click="checkThis(index)">
        <span style="color:'#666666';" class="more-span">{{item.text}}</span>
        <div :style="{display:item.isCheck?'flex':'none'}" class="check-istrator">
          <img class="check-img" src="@/assets/images/xuanzhong.png" background-size="cover" />
        </div>
      </div>
    </div>
    <div class="btn-box">
      <van-button round type="info" @click="save">保存</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      imei:'',//设备imei
      dateList:[]
    }
  },
  created(){
    console.log(this.$route.query.data,885)
    let obj = {
      '周一至周五':["周一","周二","周三","周四","周五"],
      '周一至周六':["周一","周二","周三","周四","周五","周六"],
      '周一至周日':["周一","周二","周三","周四","周五","周六","周日"]
    }
    let str = obj[this.$route.query.data]?obj[this.$route.query.data]:this.$route.query.data?this.$route.query.data:[]
    this.dateList = []
    let data = ["周一","周二","周三","周四","周五","周六","周日"]
    data.forEach((item,index) => {
      this.dateList.push({
        text:item,
        isCheck:str.includes(item)
      })
    });
  },
  methods: {
    /**
      * 返回上一级
      */
      backPage() {
          this.$router.back(-1);
      },
    //选中
    checkThis(index){
      // if(!this.dateList[index].isCheck) return
      this.dateList[index].isCheck = !this.dateList[index].isCheck
    },
    //保存
    save(){
      this.$store.commit('set_clockOption', JSON.stringify(this.dateList));
      // bus.$emit('checkClock',this.dateList)
      this.$router.back(-1);
    },
  },
}
</script>

<style scoped>
.option-date{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 100px 40px 0;
}
.more-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  margin-top: 25px;
}
.more-flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 670px;
  height: 101px;
}
.more-span{
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #111111;
  margin-left: 32px;
}
.check-istrator{
  margin-right: 40px;
}
.check-istrator .check-img{
  width: 40px;
  height: 40px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding-bottom: 70px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style>
.option-date .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
</style>
